import { apiSlice } from "../../api/apiSlice";
import { APPROVAL_HALT_REASONS, HALT_REINIT_APPROVALS, SCORECARD_HALT_APPROVALS } from "../../constants";

export const haltReinitiativeSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getApprovalHaltReasons: builder.query({
            query: (arg: any) => {
                const { typeId } = arg;
                return {
                    url: APPROVAL_HALT_REASONS,
                    params: { typeId },
                };
            },
        }),
        createApprovalsHalt: builder.mutation({
            query: (arg: any) => ({
                url: HALT_REINIT_APPROVALS,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['HaltApprovals'],
        }),
        getScorecardHaltApprovals: builder.query({
            query: (arg: any) => {
                const { year, month,scorecardVersionId } = arg;

                return {
                    url: SCORECARD_HALT_APPROVALS,
                    params: { year, month,scorecardVersionId },
                };
            },
        }),
    }),
});
export const {
    useGetApprovalHaltReasonsQuery,
    useCreateApprovalsHaltMutation,
    useGetScorecardHaltApprovalsQuery
} = haltReinitiativeSlice;
